
import { useParams } from 'react-router-dom';
import { EmpleadosFormState } from '../../../context/empleados/EmpleadosFormState';
import { Form } from './form';

export const EmpleadosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Empleado" : "Crear Empleado";

  return (
    <EmpleadosFormState>
        <br />
        <Form title={title} />
    </EmpleadosFormState>
  );
};
